import { ColorName, LabelIcon, returnColor } from '@youshift/shared/utils';

import LabelIconComponent from '../LabelIconComponent';

interface LabelBadgeProps {
  icon: LabelIcon;
  labelColor: ColorName;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

export function LabelBadge({
  icon,
  labelColor,
  size = 'sm',
  className = '',
}: LabelBadgeProps) {
  // Size mappings
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-7 h-7',
    lg: 'w-8 h-8',
  };

  const iconSizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  return (
    <div
      className={`rounded-md flex items-center justify-center ${sizeClasses[size]} ${className}`}
      style={{
        backgroundColor: returnColor(labelColor, 400),
        border: `1px solid ${returnColor(labelColor, 800)}`,
      }}
    >
      <LabelIconComponent icon={icon} className={iconSizes[size]} />
    </div>
  );
}
